<template>
  <div class="container">
    <div class="box-title" :style="{marginTop: '10px'}">
      <div class="column is-6">
        <h4 class="has-text-left" style="margin-top: -38px;">
          <i class="fal fa-list"></i>
          ລາຍການທີ່ຈະສ້າງອິນວອຍ
          <span class="countTotal">({{ count }})</span>
        </h4>
      </div>

    </div>
    <div class="box" :style="{marginTop: '-10px'}">
      <div class="columns">
        <div class="column is-2">
          <div class="control">
            <label class="label">ຈາກວັນທີ:</label>
            <date-picker
                format="DD/MM/YYYY HH:mm"
                value-type="YYYY-MM-DD HH:mm"
                type="datetime"
                v-model="start_date"
                :disabled-date="disabledAfterToday"
                :clearable="false"
                name="start_date"
            ></date-picker>
          </div>
        </div>
        <div class="column is-2">
          <div class="control">
            <label class="label">ຫາວັນທີ:</label>
            <date-picker
                format="DD/MM/YYYY H:mm"
                value-type="YYYY-MM-DD H:mm"
                type="datetime"
                v-model="end_date"
                :disabled-date="disabledAfterToday"
                :clearable="false"
                name="end_date"
            ></date-picker>
          </div>
        </div>
        <div class="column is-2" style="margin-top: 3px">
          <vs-button
              ref="button" flat
              @click="fetchData()"
              class="form-btn-loading"
              :loading="loading">
            ຄົ້ນຫາ
          </vs-button>
        </div>
        <div class="column is-2" style="margin-top: 3px">
          <vs-button
              v-if="listPayments.length !== 0"
              ref="button" flat
              @click="insertInvoice()"
              class="form-btn-loading"
              :loading="loading">
            ສ້າງອິນວອຍ
          </vs-button>
        </div>
      </div>
    </div>
    <div class="center fit-width">
      <vs-table ref="table">
        <template #thead>
          <vs-tr>
            <vs-th>ລຳດັບ</vs-th>
            <vs-th>ເລກບິນ</vs-th>
            <vs-th>ສາຂາປາຍທາງ</vs-th>
            <vs-th>ຈຳນວນ</vs-th>
            <vs-th>ວັນທີ</vs-th>
          </vs-tr>
        </template>
        <template #tbody>
          <vs-tr
              :key="index"
              :data="payment"
              v-for="(payment, index) in $vs.getPage(listPayments, page, max)">
            <vs-td>{{ index + 1 }}</vs-td>
            <vs-td>{{ payment.shipment_number }}</vs-td>
            <vs-td>{{ payment.name }}</vs-td>
            <vs-td>{{ FormatPrice(payment.paid) }}</vs-td>
            <vs-td>{{ moment(payment.created_at).format('DD-MM-YYYY HH:mm') }}</vs-td>
          </vs-tr>
        </template>
        <template #footer>
          <pagination :pagination="pagination" :offset="offset"
                      @paginate="fetchData"></pagination>
          <Loading v-if="isLoading"/>
        </template>
      </vs-table>
    </div>
  </div>
</template>
<script>
import Loading from "@/views/Loading";
import {mapActions} from "vuex";
import pagination from '@/Plugins/Paginations/CusorPagination';
import * as helper from "@/Helpers/GetValue";
import DatePicker from "vue2-datepicker";
import moment from "moment";

export default {
  components: {
    Loading,
    pagination,
    DatePicker
  },

  props: ['onclickEvent'],

  data: () => ({
    laStatus: {
      0: 'ກຳລັງດຳເນີນການ',
      1: 'ສຳເລັດ'
    },
    page: 1,
    max: 10,
    start_date: moment(new Date()).format('YYYY-MM-DD 00:00'),
    end_date: moment(new Date()).format('YYYY-MM-DD 23:59'),
    isLoading: false,
    listPayments: [],
    // Pagination
    count: 0,
    offset: 10,
    limit_page: 10,
    pagination: {},
    //Export
    actualSelectedItems: [],
    isSelecting: false,
    pageInvoices: [],
    loading: false,
    checkedAll: false,
  }),

  methods: {
    insertInvoice() {
      const loading = this.BtnLoading();
      this.loading = true;
      this.$http.post('/insert/invoice/local', {
        start_date: this.start_date,
        end_date: this.end_date,
        type: this.$route.query.tab,
      }).then(() => {
        setTimeout(() => {
          this.loading = false;
          loading.close();
          this.fetchData();
        }, 500);
      }).catch(() => {
        this.loading = false;
        loading.close()
      });
    },

    FormatPrice(price) {
      let p = (parseInt(price) || 0).toFixed(2).split(".");
      return p[0].split("").reverse().reduce(function (acc, price, i) {
        return price === "-" ? acc : price + (i && !(i % 3) ? "," : "") + acc;
      }, "");
    },
    disabledAfterToday(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      return date > today;
    },
    disableDateCustomer(date) {
      const fixDay = moment('2021-08-01 00:00:00');
      return date < fixDay;
    },
    fetchData() {
      this.isLoading = true;
      this.fetchInvoiceItemsResponse().then((res) => {
        if (!res.data.error) {
          setTimeout(() => {
            this.listPayments = res.data.data.data.data;
            this.count = res.data.data.total;
            this.pagination = res.data.data.data;
          }, 300);
        }
        this.isLoading = false;
      }).catch(() => {
        this.isLoading = false;
      });
    },

    fetchInvoiceItemsResponse(options = {}) {
      const {current_page, per_page} = options;
      return this.$http.get('list/insert/invoice/local', {
        params: {
          start_date: this.start_date,
          end_date: this.end_date,
          type: this.$route.query.tab,
          cursor: current_page ?? this.pagination.cursor,
          per_page: per_page ?? this.limit_page,
        }
      })
    },
    FilterBySearch() {
      helper.GetOldValueOnInput(this);
    },
    ...mapActions({
      LogoutUser: "User/destroyToken",
    }),

    BtnLoading() {
      return this.$vs.loading({
        target: this.$refs.table,
        scale: "1",
        background: "primary",
        opacity: 1,
        color: "#195BFF",
      });
    },
  },
  watch: {
    'onclickEvent': function (value) {
      if (value !== '') {
        this.listPayments = [];
        this.count = 0;
        this.pagination = {};
      }
    }
  }
};
</script>
<style lang="scss" scope>
.container {
  margin-top: 40px;

  .title-login {
    font-size: 20px;
    color: $primary-color;
  }
}

.fit-width {
  white-space: nowrap;
}

.vs-table__td,
.vs-table__th {
  vertical-align: middle !important;
  white-space: nowrap !important;
  width: 1px !important;
}

</style>
